import HTTP from "../../utility/http";
import FILE from "../../utility/file";
const clone = require("lodash/cloneDeep");
import { asyncHandler } from "@/utility/async";

const state = {
  outfitters: [],
  outfitter: {
    discounts: [],
    price_groups: [],
    display_group_only: 0,
  },
};

const getters = {
  getOutfitters: (state) => state.outfitters,
  getOutfitter: (state) => {
    let outfitter = clone(state.outfitter);
    outfitter.processing_fee = outfitter.processing_fee / 100;
    outfitter.display_group_price = outfitter.display_group_price / 100;
    return outfitter;
  },
  getDiscounts: (state) => {
    let discounts = clone(state.outfitter.discounts);
    discounts.forEach((discount) => {
      discount.value = discount.value / 100;
    });
    return discounts;
  },
  getPriceGroups: (state) => {
    let groups = clone(state.outfitter.price_groups);
    groups.forEach((group) => {
      group.price = group.price / 100;
    });
    return groups;
  },
};

const actions = {
  async add_river_section(context, data) {
    return await asyncHandler(
      HTTP({
        url: "outfitter/river-section",
        method: "POST",
        data,
      })
    );
  },

  async remove_river_section(context, data) {
    return await asyncHandler(
      HTTP({
        url: "outfitter/river-section/" + data.id + "/" + data.outfitterId,
        method: "DELETE",
      })
    );
  },

  async delete_price_group(context, id) {
    return await asyncHandler(
      HTTP({ url: "price_group/" + id, method: "DELETE" })
    );
  },

  async save_price_group(context, d) {
    let data = clone(d);
    const url = data.id ? "price_group/" + data.id : "price_group";
    const method = data.id ? "PUT" : "POST";
    data.price = data.price * 100;
    return await asyncHandler(HTTP({ url, method, data }));
  },

  async delete_discount(context, id) {
    return await asyncHandler(
      HTTP({ url: "discount/" + id, method: "DELETE" })
    );
  },

  async save_discount(context, d) {
    let data = clone(d);
    const url = data.id ? "discount/" + data.id : "discount";
    const method = data.id ? "PUT" : "POST";
    data.value = data.value * 100;
    return await asyncHandler(HTTP({ url, method, data }));
  },

  async save_logo({ commit }, data) {
    let formData = new FormData();
    formData.append("file", data.file);
    formData.append("id", data.id);
    const resp = await asyncHandler(
      FILE({
        url: "/outfitter/save-logo",
        method: "POST",
        data: formData,
      })
    );
    if (resp.success) {
      commit("set_logo", resp.logo);
    }
    return resp;
  },

  async get_outfitter({ commit }, id) {
    const resp = await asyncHandler(
      HTTP({ url: "outfitter/" + id, method: "GET" })
    );
    if (resp.success) {
      commit("set_outfitter", resp.outfitter);
    }
    return resp;
  },

  async reload_outfitter({ commit }, id) {
    const resp = await asyncHandler(
      HTTP({ url: "outfitter/" + id, method: "GET" })
    );
    if (resp.success) {
      commit("set_outfitter", resp.outfitter);
    }
    return resp;
  },

  async all({ commit }, data) {
    const resp = await asyncHandler(
      HTTP({
        url: "outfitter/all/" + data.withDeleted,
        method: "GET",
      })
    );
    if (resp.success) {
      commit("set_outfitters", resp.outfitters);
    }
    return resp;
  },

  async reload({ commit }, data) {
    const resp = await asyncHandler(
      HTTP({
        url: "outfitter/all/" + data.withDeleted,
        method: "GET",
      })
    );
    if (resp.success) {
      commit("set_outfitters", resp.outfitters);
    }
    return resp;
  },

  async save_outfitter({ commit }, d) {
    let data = clone(d);
    const url = data.id ? "outfitter/" + data.id : "outfitter";
    const method = data.id ? "PUT" : "POST";
    data.processing_fee = data.processing_fee * 100;
    data.display_group_price = data.display_group_price * 100;
    delete data.logo_path;
    const resp = await asyncHandler(HTTP({ url, method, data }));
    if (resp.success) {
      commit("set_outfitter", resp.outfitter);
    }
    return resp;
  },

  async delete_outfitter(context, data) {
    return await asyncHandler(
      HTTP({ url: "outfitter/" + data.id, method: "DELETE" })
    );
  },

  async restore_outfitter(context, data) {
    return await asyncHandler(
      HTTP({
        url: "outfitter/restore/" + data.id,
        method: "GET",
      })
    );
  },
};

const mutations = {
  set_outfitters: (state, outfitters) => {
    state.outfitters = outfitters;
  },
  set_outfitter: (state, outfitter) => {
    state.outfitter = outfitter;
  },
  set_logo: (state, logo) => {
    state.outfitter.logo_path = logo;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
